export const ConstantsUtil = {
    FIVE_MINUTES_IN_MS: 300000
};
//# sourceMappingURL=ConstantsUtil.js.map